const DarkTheme = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="1920"
    height="1080"
    viewBox="0 0 1920 1080"
  >
    <defs>
      <clipPath id="clip-dark">
        <rect width="1920" height="1080" />
      </clipPath>
    </defs>
    <g id="dark" clipPath="url(#clip-dark)">
      <rect width="1920" height="1080" fill="#1a1a1a" />
      <rect
        id="Rectangle_7"
        data-name="Rectangle 7"
        width="300"
        height="1080"
        fill="#3a3a3a"
      />
      <rect
        id="Rectangle_8"
        data-name="Rectangle 8"
        width="1620"
        height="500"
        transform="translate(300)"
        fill="#2a2a2a"
      />
      <rect
        id="Rectangle_9"
        data-name="Rectangle 9"
        width="1620"
        height="10"
        transform="translate(300 500)"
        fill="#3a3a3a"
      />
      <rect
        id="Rectangle_10"
        data-name="Rectangle 10"
        width="240"
        height="30"
        rx="10"
        transform="translate(390 570)"
        fill="#2a2a2a"
      />
      <rect
        id="Rectangle_11"
        data-name="Rectangle 11"
        width="240"
        height="340"
        rx="10"
        transform="translate(390 630)"
        fill="#2a2a2a"
      />
      <rect
        id="Rectangle_12"
        data-name="Rectangle 12"
        width="240"
        height="340"
        rx="10"
        transform="translate(690 630)"
        fill="#2a2a2a"
      />
      <rect
        id="Rectangle_13"
        data-name="Rectangle 13"
        width="240"
        height="340"
        rx="10"
        transform="translate(990 630)"
        fill="#2a2a2a"
      />
      <rect
        id="Rectangle_14"
        data-name="Rectangle 14"
        width="240"
        height="340"
        rx="10"
        transform="translate(1290 630)"
        fill="#2a2a2a"
      />
      <rect
        id="Rectangle_15"
        data-name="Rectangle 15"
        width="240"
        height="340"
        rx="10"
        transform="translate(1590 630)"
        fill="#2a2a2a"
      />
    </g>
  </svg>
);

export default DarkTheme;
